<template>
  <div class="wrapper" :class="{ mobile: !isLargeScreen }">
    <div class="overview">
      <div class="overview-title">
        <h2>Overview</h2>
      </div>
      <div class="overview-contents" :class="{ 'fixed-width': isLargeScreen }">
        <div>
          <FiringAlertsRSCard
            :firingAlertsAmount="firingAlertsAmountOfSelectedAccount"
            :lastFiringAlert="lastFiringAlertOfSelectedAccount"
          >
          </FiringAlertsRSCard>
        </div>
      </div>
    </div>
    <div class="alerts">
      <div v-if="isLargeScreen">
        <div class="alerts-title">
          <h2>Your alerts</h2>
          <div class="search-and-create">
            <div class="search-alert">
              <SearchBoxAlertsRS
                placeholder="Search for alert name"
                :isWithIcon="true"
              ></SearchBoxAlertsRS>
            </div>
            <div class="create-alert">
              <button class="btn btn-primary" @click="showCreateAlertModal">
                New alert
              </button>
            </div>
            <div class="icon-container">
              <fa
                v-if="!isExpandStatusIndicators"
                icon="question-circle"
                v-tooltip.top="{ content: 'Alert status indicators' }"
                @click="isExpandStatusIndicators = true"
              ></fa>
              <fa
                v-if="isExpandStatusIndicators"
                icon="chevron-up"
                @click="isExpandStatusIndicators = false"
              ></fa>
            </div>
          </div>
        </div>

        <div
          ref="accordionContent"
          class="status-indicators-content"
          :class="{ show: isExpandStatusIndicators }"
        >
          <h5>Alert status indicators</h5>
          <AlertStatusIndicators></AlertStatusIndicators>
        </div>
      </div>
      <div v-else class="mobile">
        <div class="alerts-title">
          <h2>Your alerts</h2>
          <div class="search-and-create">
            <div class="create-alert">
              <button class="btn btn-primary" @click="showCreateAlertModal">
                New alert
              </button>
            </div>
          </div>
        </div>

        <div
          class="indicator-toggle"
          @click="isExpandStatusIndicators = !isExpandStatusIndicators"
        >
          <p>Alert status indicators</p>
          <div class="icon-wrapper">
            <fa
              icon="chevron-down"
              :class="{ 'fa-rotate-180': isExpandStatusIndicators }"
            ></fa>
          </div>
        </div>
        <div
          ref="accordionContent"
          class="status-indicators-content"
          :class="{ show: isExpandStatusIndicators }"
        >
          <AlertStatusIndicators></AlertStatusIndicators>
        </div>

        <div class="icon-group-and-search">
          <div class="icon-group">
            <fa
              icon="sort-amount-down"
              class="icon"
              :class="{ active: isShowSortTool }"
              @click="toggleIsShowSortTool"
            ></fa>
            <fa
              icon="filter"
              class="icon"
              :class="{ active: isShowFilterTool }"
              @click="toggleIsShowFilterTool"
            ></fa>
          </div>
          <div class="search-alert">
            <SearchBoxAlertsRS
              placeholder="Search for alert name"
              :isWithIcon="true"
              @onCloseSearchBox="closeSearchBox"
            ></SearchBoxAlertsRS>
          </div>
        </div>
        <div v-if="isShowSortTool" class="tool">
          <SortAndFilterToolAlertsRS
            :toolConfig="sortToolConfig"
            @onToolChange="handleSortToolChange"
          ></SortAndFilterToolAlertsRS>
        </div>
        <div v-if="isShowFilterTool" class="tool">
          <SortAndFilterToolAlertsRS
            :toolConfig="filterToolConfig"
            @onToolChange="handleFilterToolChange"
          ></SortAndFilterToolAlertsRS>
        </div>
      </div>
      <div v-if="isLargeScreen" class="alerts-content">
        <AlertRSTable
          @onEditAlert="editAlertRS"
          @onSnoozeAlert="snoozeAlert"
          @onUnSnoozeAlert="unSnooze"
          @onDeleteAlert="deleteAlert"
        ></AlertRSTable>
      </div>
      <div v-else class="alerts-content">
        <MobileAlertRSCard
          :sortType="sortType"
          :filterType="filterType"
          @onEditAlert="editAlertRS"
          @onSnoozeAlert="snoozeAlert"
          @onUnSnoozeAlert="unSnooze"
          @onDeleteAlert="deleteAlert"
          @onCloseFilterTool="handleCloseFilterTool"
        ></MobileAlertRSCard>
      </div>
    </div>

    <ModalContainer
      v-if="showMoreModalObj.isShown"
      :modalTitle="showMoreModalTitle"
      closeBtnText="Close"
      widthOnMobile="95%"
      @closeModal="
        setShowMoreModalObj({
          isShown: false,
          bodyTextOfTriggers: '',
          bodyTextOfIncident: '',
          bodyTextOfFilters: '',
          modalType: '',
          alertId: null
        })
      "
    >
      <template slot="header">
        <div v-if="isCopiedShown" class="copied">Copied!</div>
      </template>
      <template slot="body">
        <div class="tools-wrapper">
          <div class="switch">
            <span
              v-if="
                showMoreModalObj.modalType === SHOW_MORE_MODAL_TYPE.TRIGGERS
              "
              @click="
                setShowMoreModalObj({
                  modalType: SHOW_MORE_MODAL_TYPE.INCIDENT
                })
              "
              >Incident</span
            >
            <span
              v-if="
                showMoreModalObj.modalType === SHOW_MORE_MODAL_TYPE.INCIDENT
              "
              @click="
                setShowMoreModalObj({
                  modalType: SHOW_MORE_MODAL_TYPE.TRIGGERS
                })
              "
              >Triggers</span
            >
          </div>
          <div class="copy" @click="copyBodyText">
            <fa icon="copy" class="icon"></fa>
            <span>
              Copy all
            </span>
          </div>
        </div>
        <p
          class="body-text"
          v-if="showMoreModalObj.modalType === SHOW_MORE_MODAL_TYPE.TRIGGERS"
        >
          {{ showMoreModalObj.bodyTextOfTriggers }}
        </p>
        <p
          class="body-text"
          v-if="showMoreModalObj.modalType === SHOW_MORE_MODAL_TYPE.INCIDENT"
        >
          {{ showMoreModalObj.bodyTextOfIncident }}
        </p>
        <p
          class="body-text filters"
          v-if="showMoreModalObj.modalType === SHOW_MORE_MODAL_TYPE.FILTERS"
        >
          {{ showMoreModalObj.bodyTextOfFilters }}
        </p>
      </template>
    </ModalContainer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import FiringAlertsRSCard from './overviewCards/FiringAlertsRSCard.vue';
import AlertRSTable from './AlertRSTable.vue';
import SearchBoxAlertsRS from '../../ui/SearchBoxAlertsRS.vue';
import SortAndFilterToolAlertsRS from './alertTableParts/SortAndFilterToolAlertsRS.vue';
import MobileAlertRSCard from './alertTableParts/MobileAlertRSCard.vue';
import {
  ALERT_SORT_OPTION,
  ALERT_FILTER_OPTION
} from '../../../constants/alertsConstant';
import ModalContainer from '../../ui/ModalContainer.vue';
import { SHOW_MORE_MODAL_TYPE } from '../../../constants/alertsRoutingStatusConstant';
import AlertStatusIndicators from '../../../components/ui/AlertStatusIndicators.vue';
import { scrollToShowElementBottom } from '../../../utils/BOM';

export default {
  name: 'OverviewRS',
  components: {
    FiringAlertsRSCard,
    AlertRSTable,
    SearchBoxAlertsRS,
    SortAndFilterToolAlertsRS,
    MobileAlertRSCard,
    ModalContainer,
    AlertStatusIndicators
  },
  data() {
    return {
      isExpandStatusIndicators: false,
      isShowSearchAlert: false,
      isShowSortTool: false,
      isShowFilterTool: false,
      sortType: 0,
      filterType: 0,
      sortToolConfig: {
        placeholder: 'Sort',
        toolList: [
          { id: ALERT_SORT_OPTION.NONE, text: 'None' },
          {
            id: ALERT_SORT_OPTION.NAME_ASCENDING,
            text: 'Name (alphabetically)'
          },
          {
            id: ALERT_SORT_OPTION.LAST_TRIGGER_NEWEST_FIRST,
            text: 'Last trigger: newest first'
          },
          {
            id: ALERT_SORT_OPTION.LAST_TRIGGER_OLDEST_FIRST,
            text: 'Last trigger: oldest first'
          }
        ]
      },
      filterToolConfig: {
        placeholder: 'Filter',
        toolList: [
          { id: ALERT_FILTER_OPTION.NONE, text: 'None' },
          {
            id: ALERT_FILTER_OPTION.FIRING,
            text: 'Firing'
          },
          {
            id: ALERT_FILTER_OPTION.FIRED,
            text: 'Fired'
          },
          {
            id: ALERT_FILTER_OPTION.SNOOZED,
            text: 'Snoozed'
          },
          {
            id: ALERT_FILTER_OPTION.CLEAN,
            text: 'Clean'
          }
        ]
      },
      SHOW_MORE_MODAL_TYPE: SHOW_MORE_MODAL_TYPE,
      isCopiedShown: false,
      timer: null
    };
  },
  computed: {
    ...mapState('alertsRoutingStatusStore', ['showMoreModalObj']),
    ...mapGetters(['isLargeScreen', 'isMobile']),
    ...mapGetters('alertsRoutingStatusStore', [
      'firingAlertsAmountOfSelectedAccount',
      'lastFiringAlertOfSelectedAccount',
      'alertsListOfSelectedAccount'
    ]),
    showMoreModalTitle() {
      const { alertId } = this.showMoreModalObj;

      if (!alertId) {
        return `Alert ${this.showMoreModalObj.modalType}`;
      } else {
        const alertObj = this.alertsListOfSelectedAccount.find(
          item => item.id === alertId
        );

        if (alertObj && alertObj.name) {
          return `Alert ${this.showMoreModalObj.modalType} for ${
            alertObj.name
          }`;
        } else {
          return `Alert ${this.showMoreModalObj.modalType}`;
        }
      }
    }
  },
  watch: {
    isExpandStatusIndicators(val) {
      if (val && this.$refs.accordionContent) {
        setTimeout(() => {
          scrollToShowElementBottom(this.$refs.accordionContent);
        }, 500);
      }
    }
  },
  methods: {
    ...mapActions('alertsRoutingStatusStore', ['unSnoozeAlert']),
    ...mapMutations('alertsRoutingStatusStore', [
      'setEditingAlertObj',
      'setIsEditingAlert',
      'setIsShowCreateAlertModal',
      'setIsShowSnoozeAlertModal',
      'setIsShowDeleteAlertModal',
      'setShowMoreModalObj'
    ]),

    ...mapMutations('alertsRoutingStatusStore', ['setIsShowCreateAlertModal']),

    showCreateAlertModal() {
      this.setIsShowCreateAlertModal(true);
    },

    handleSortChange(val) {
      this.sortType = val;
    },

    handleSortToolChange(val) {
      this.sortType = val;
    },

    handleFilterToolChange(val) {
      this.filterType = val;
    },

    editAlertRS(val) {
      const editingAlertRS = this.alertsListOfSelectedAccount.find(
        alert => alert.id === val
      );
      this.setEditingAlertObj(editingAlertRS);
      this.setIsEditingAlert(true);
      this.setIsShowCreateAlertModal(true);
    },

    snoozeAlert(val) {
      const alert = this.alertsListOfSelectedAccount.find(
        alert => alert.id === val
      );
      this.setEditingAlertObj(alert);
      this.setIsShowSnoozeAlertModal(true);
    },

    unSnooze(val) {
      const alert = this.alertsListOfSelectedAccount.find(
        alert => alert.id === val
      );
      this.setEditingAlertObj(alert);
      this.unSnoozeAlert();
    },

    deleteAlert(val) {
      const deletingAlertRS = this.alertsListOfSelectedAccount.find(
        alert => alert.id === val
      );

      this.setEditingAlertObj(deletingAlertRS);
      this.setIsShowDeleteAlertModal(true);
    },

    showSearchBox() {
      this.isShowSearchAlert = true;
    },

    closeSearchBox() {
      this.isShowSearchAlert = false;
    },

    toggleIsShowSortTool() {
      this.isShowSortTool = !this.isShowSortTool;
      if (!this.isShowSortTool) this.sortType = ALERT_SORT_OPTION.NONE;
    },

    toggleIsShowFilterTool() {
      this.isShowFilterTool = !this.isShowFilterTool;
      if (!this.isShowFilterTool) this.filterType = ALERT_FILTER_OPTION.NONE;
    },

    handleCloseFilterTool() {
      if (this.isShowFilterTool) this.toggleIsShowFilterTool();
    },

    copyBodyText() {
      if (this.showMoreModalObj.modalType === SHOW_MORE_MODAL_TYPE.TRIGGERS)
        navigator.clipboard.writeText(this.showMoreModalObj.bodyTextOfTriggers);

      if (this.showMoreModalObj.modalType === SHOW_MORE_MODAL_TYPE.INCIDENT)
        navigator.clipboard.writeText(this.showMoreModalObj.bodyTextOfIncident);

      if (this.showMoreModalObj.modalType === SHOW_MORE_MODAL_TYPE.FILTERS)
        navigator.clipboard.writeText(this.showMoreModalObj.bodyTextOfFilters);

      if (this.timer) clearTimeout(this.timer);
      this.isCopiedShown = true;
      this.timer = setTimeout(() => {
        this.isCopiedShown = false;
      }, 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
.overview {
  margin-bottom: 3rem;

  .overview-title {
    margin-bottom: 1.5rem;
  }
}
h2 {
  font-size: 1.75rem;
}

.alerts-title {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;

  h2 {
    margin: 0;
  }

  .search-and-create {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

    .create-alert {
      margin-left: 2rem;
    }

    .icon-container {
      width: 2.5rem;

      svg {
        margin-left: 1rem;
        font-size: 1.25rem;
        color: $icon-grey;
        cursor: pointer;
      }
    }
  }
}

.status-indicators-content {
  border: none;
  padding: 0;
  opacity: 0;
  height: auto;
  max-height: 0;
  overflow: hidden;
  transition-property: opacity max-height;
  transition-duration: 0.5s;

  &.show {
    opacity: 1;
    padding-top: 1rem;
    margin-bottom: 1rem;
    max-height: 50rem;
    border-top: 1px solid #bbb;
    border-bottom: 1px solid #bbb;
  }
}

.overview-contents {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 49%;

  & > div {
    width: 100%;
  }

  .wrapper {
    width: 100%;
  }
}

.copied {
  position: absolute;
  z-index: 1;
  right: 1.75rem;
  top: 2rem;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  color: #ffffff;
  background-color: #208836;
}

// Add an arrow at the bottom of copied prompt
.copied::after {
  content: '';
  position: absolute;
  left: calc(50% - 0.5rem);
  top: 100%;
  border: 0.5rem solid transparent;
  border-top-color: #208836;
}

.tools-wrapper {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0 1rem;
  color: $text-light-blue;

  .switch {
    cursor: pointer;
  }

  .copy {
    cursor: pointer;

    &:hover {
      font-weight: 600;
    }
  }
}

.body-text {
  padding: 1rem;
  height: calc(100vh - 18rem);
  overflow-y: auto;
  border: 1px solid #d9d9d9;

  &.filters {
    height: calc(80vh - 18rem);
  }
}

.mobile {
  .indicator-toggle {
    display: flex;
    align-items: center;
    margin: 0;
    width: 16rem;

    p {
      margin: 0;
      border-bottom: 1px solid $text-black;
      cursor: pointer;
    }

    .icon-wrapper {
      padding: 0.5rem;
      padding-right: 1.5rem;
      cursor: pointer;

      svg {
        transition: transform 0.5s;
      }
    }
  }

  .status-indicators-content.show {
    border: none;
  }

  .overview-contents {
    flex-direction: column;
    width: 100%;

    &.fixed-width {
      width: 49%;
    }
  }

  .alerts-title {
    flex-wrap: wrap;
  }

  .search-alert {
    margin: 0.5rem 0;
  }

  .icon-group-and-search {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    .icon {
      padding: 0.5rem;
      margin-right: 0.5rem;
      width: 2rem;
      height: 2rem;
      color: $icon-grey;
    }

    .active {
      color: $text-light-blue;
    }
  }

  .tool {
    padding-bottom: 0.5rem;
  }

  .body-text {
    &.filters {
      height: calc(100vh - 18rem);
    }
  }
}
</style>
